import { gql } from '@apollo/client';

export const USER_PROFILE_FRAGMENT = gql(`
  fragment UserProfileFields on UserProfileResponse {
    id
    complete_name
    email
    location
    phone
    age
    summary
    headline
    skills
    verified
    photoUrl
    language
    createdAt
    updatedAt
    experiences {
      id
      companyName
      title
      description
      logo
      workPlace
      startDate
      endDate
      location
      current
      skills
      createdAt
      updatedAt
    }
    educations {
      id
      school
      title
      description
      startDate
      endDate
      current
      createdAt
      updatedAt
    }
    languages {
      id
      language
      writing_level
      speaking_level
      createdAt
      updatedAt
    }
    certifications {
      id
      title
      deliveredBy
      url
      date
      createdAt
      updatedAt
    }
  }
`);

export const UPDATE_PROFILE_MUTATION = gql`
  mutation updateProfile($data: UpdateProfileInput!) {
    updateProfile(data: $data) {
      ...UserProfileFields
    }
  }
  ${USER_PROFILE_FRAGMENT}
`;

export const GET_PROFILE_QUERY = gql`
  query getProfile {
    getProfile {
      ...UserProfileFields
    }
  }
  ${USER_PROFILE_FRAGMENT}
`;

export const GOOGLE_LOGIN_MUTATION = gql`
  mutation GoogleLogin($token: String!) {
    googleLogin(token: $token) {
      user {
        id
        email
        complete_name
        photoUrl
      }
      profile {
        ...UserProfileFields
      }
      jwt
    }
  }
  ${USER_PROFILE_FRAGMENT}
`;
